import {AvantButton} from "../../../generic-components/AvantButton";
import * as React from "react";
import {LoginDTO} from "../../../../types/types";

export function RosterTestTakers({login, handleRosterStudents}: {login: LoginDTO; handleRosterStudents: (l: LoginDTO | undefined) => void}) {
    return (
        <AvantButton
            onClick={() => handleRosterStudents(login)}
        >
        Roster Test Takers
        </AvantButton>
    )
}